<template>
    <div class="coop-item">
        <div class="top" :class="{active: isOpen}" @click="isOpen = !isOpen">
            <div class="item-name">
                <span class="icon-circle"></span>
                <span>{{vm.name}}</span>
            </div>
            <img class="icon-arrow" :src="imgUrl">
        </div>
        <div class="item-detail" v-if="isOpen">
            <p class="item-des">{{vm.des}}</p>
            <div class="img-box">
                <img class="img-des" :src="vm.imgs">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        vm: {
            type: Object,
            default: () => {}
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isOpen: false,
            first: this.isFirst
        }
    },
    computed: {
        imgUrl () {
            return this.isOpen ? 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/icon-arrow-active.png' : 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/home/icon-arrow.png'
        }
    },
    created () {
        if (this.first) {
            this.isOpen = true
            this.first = false
        }
    }
}
</script>
<style lang="scss" scoped>
.coop-item{
    width: 100%;
    border-bottom: 1px solid #F0F0F0;
    .top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 47px;
        .item-name{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#272727;
            line-height:17px;
            .icon-circle{
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #272727;
                margin-right: 5px;
            }
        }
        .icon-arrow{
            width: 11px;
            height: 11px;
        }
        &.active{
            .item-name{
                color: #0182FF;
            }
            .icon-circle{
                background: #0182FF;
            }
        }
    }
    .item-detail{
        padding-left: 9px;
        padding-bottom: 20px;
        .item-des{
            font-size:10px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#1C1C1C;
            line-height:14px;
            margin-top: 8px;
        }
        .img-box{
            margin-top: 12px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .img-des{
                width: 100%;
            }
        }
    }
}
</style>